import { FiHome, FiKey, FiAnchor } from "react-icons/fi";
import { CgTrees } from "react-icons/cg";
import { BiShieldAlt2 } from "react-icons/bi";
import { GoRocket } from "react-icons/go";

// Re-export image-heavy data from propertyData.js so existing imports don't break
export {
  properties,
  review,
  teamdata,
  categoriesData,
  blogList,
  aboutData,
  agentData,
  agencyData,
} from "./propertyData";

export const featureData = [
  {
    icon: FiHome,
    title: "Luxury Waterfront Homes",
    desc: "Premium fully-furnished Florida waterfront homes with direct Gulf access, salt water pools, boat lifts, and turnkey amenities.",
  },
  {
    icon: FiAnchor,
    title: "Liveaboard Boat Slips",
    desc: "Rare grandfathered liveaboard slips at the iconic Lorelei Cabana Bar in Islamorada — dockage, utilities, and amenities included.",
  },
  {
    icon: FiKey,
    title: "Premium Service",
    desc: "Dedicated property management, maintenance support, and personalized concierge services for an exceptional rental experience.",
  },
];

export const counterData = [
  {
    target: "50",
    title: "Luxury Properties",
    sign: "+",
  },
  {
    target: "30",
    title: "Boat Slips",
    sign: "+",
  },
  {
    target: "100",
    title: "Client Satisfaction",
    sign: "%",
  },
];

export const featureTwo = [
  {
    icon: "mdi mdi-cards-heart",
    title: "Comfortable",
    desc: "If the distribution of letters and words is random, the reader will not be distracted from making.",
  },
  {
    icon: "mdi mdi-shield-sun",
    title: "Extra Security",
    desc: "If the distribution of letters and words is random, the reader will not be distracted from making.",
  },
  {
    icon: "mdi mdi-star",
    title: "Luxury",
    desc: "If the distribution of letters and words is random, the reader will not be distracted from making.",
  },
  {
    icon: "mdi mdi-currency-usd",
    title: "Best Price",
    desc: "If the distribution of letters and words is random, the reader will not be distracted from making.",
  },
  {
    icon: "mdi mdi-map-marker",
    title: "Stratagic Location",
    desc: "If the distribution of letters and words is random, the reader will not be distracted from making.",
  },
  {
    icon: "mdi mdi-chart-arc",
    title: "Efficient",
    desc: "If the distribution of letters and words is random, the reader will not be distracted from making.",
  },
];

export const pricing = [
  {
    icon: CgTrees,
    title: "Basic",
    amount: "19",
    features: [
      "Full Access",
      "Source Files",
      "Free Appointments",
      "Enhanced Security",
    ],
  },
  {
    icon: BiShieldAlt2,
    title: "Premium",
    amount: "39",
    features: [
      "Full Access",
      "Source Files",
      "Free Appointments",
      "Enhanced Security",
    ],
  },
  {
    icon: GoRocket,
    title: "Business",
    amount: "99",
    features: [
      "Full Access",
      "Source Files",
      "Free Appointments",
      "Enhanced Security",
    ],
  },
];
export const accordionData = [
  {
    title: "How does it work ?",
    content:
      "There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form.",
  },
  {
    title: "Do I need a designer to use Hously ?",
    content:
      "There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form.",
  },
  {
    title: "What do I need to do to start selling ?",
    content:
      "There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form.",
  },
  {
    title: "What happens when I receive an order ?",
    content:
      "There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form.",
  },
];
